import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { HeartlandPaymentComponent } from './payment-forms/heartland-payment/heartland-payment.component';
import { RecaptchaV3Component } from './recaptcha/recaptcha-v3/recaptcha-v3.component';
import { ProductFieldComponent } from './product-field/product-field.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { SingleProductFieldComponent } from './single-product-field/single-product-field.component';
import { HeartlandTokenizerComponent } from 'src/app/formiobuilder/components/custom-builder-components/heartland-tokenizer/heartland-tokenizer.component';
import { CommercialLineItemComponent } from 'src/app/formiobuilder/components/custom-builder-components/commercial-line-item/commercial-line-item.component';
import { FormsModule } from '@angular/forms';
import { FormioModule } from 'angular-formio';
import { SafeHtmlPipe } from 'src/app/formiobuilder/components/custom-builder-components/safe-html.pipe';

@NgModule({
  declarations: [
    HeartlandTokenizerComponent,
    CommercialLineItemComponent,
    ProductFieldComponent,
    TermsConditionComponent,
    SingleProductFieldComponent,
    RecaptchaV3Component,
    HeartlandPaymentComponent,
    SafeHtmlPipe,
  ],
  providers: [DatePipe, CurrencyPipe, SafeHtmlPipe],
  imports: [CommonModule, FormioModule, FormsModule],
})
export class CustomFormsModule {}
